import React, { useState } from "react";
import DagelijksFormulier from "./details/DagelijksFormulier";
import EtenNotities from "./details/EtenNotities";
import HongerControle from "./details/HongerControle";
import { getUser, getVoedingID } from "../../../Localstorage/localstorage";

const STEPS = [
  { id: 0, label: "Eetdagboek", short: "1" },
  { id: 1, label: "Honger & eetlust", short: "2" },
  { id: 2, label: "Dagelijkse gewoonten", short: "3" },
];

const VoedingForm = ({ setOpen, userdetails }) => {
  const [selected, setSelected] = useState(0);
  const voeding = getVoedingID();
  const user = getUser();

  return (
    <div className="text-wa-text">
      <div className="border-b border-wa-border pb-4 sm:pb-5">
        <h2 className="text-center text-xl font-bold tracking-tight text-wa-text sm:text-left sm:text-2xl">
          Voedingsvragenlijst
        </h2>
        <p className="mt-1 text-center text-sm text-wa-muted sm:text-left">
          Pre-intake: vul de drie onderdelen in. Uw antwoorden worden per stap
          opgeslagen.
        </p>
        <nav
          className="mt-4 flex flex-wrap items-center justify-center gap-2 sm:justify-start"
          aria-label="Stappen voedingsvragenlijst"
        >
          {STEPS.map((step, i) => {
            const active = selected === step.id;
            const done = selected > step.id;
            return (
              <React.Fragment key={step.id}>
                {i > 0 && (
                  <span
                    className="hidden text-wa-muted sm:inline"
                    aria-hidden
                  >
                    /
                  </span>
                )}
                <span
                  className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold transition-colors sm:text-sm ${
                    active
                      ? "border-wa-accent/50 bg-wa-accent/15 text-wa-accent"
                      : done
                        ? "border-wa-border bg-wa-panel/50 text-wa-muted"
                        : "border-wa-border bg-wa-panel2/40 text-wa-muted"
                  }`}
                >
                  <span
                    className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] ${
                      active
                        ? "bg-wa-accent text-wa-onaccent"
                        : done
                          ? "bg-wa-accent/30 text-wa-accent"
                          : "bg-wa-border text-wa-muted"
                    }`}
                  >
                    {step.short}
                  </span>
                  <span className="max-w-[10rem] truncate sm:max-w-none">
                    {step.label}
                  </span>
                </span>
              </React.Fragment>
            );
          })}
        </nav>
      </div>

      <div className="mt-4 sm:mt-6">
        {selected === 0 ? (
          <EtenNotities
            setSelected={setSelected}
            voeding={voeding}
            admin={user?.role == 1 ? user : null}
            setOpen={setOpen}
            userdetails={userdetails}
          />
        ) : selected === 1 ? (
          <HongerControle
            setSelected={setSelected}
            voeding={voeding}
            admin={user?.role == 1 ? user : null}
            setOpen={setOpen}
            userdetails={userdetails}
          />
        ) : (
          <DagelijksFormulier
            setSelected={setSelected}
            voeding={voeding}
            admin={user?.role == 1 ? user : null}
            setOpen={setOpen}
            userdetails={userdetails}
          />
        )}
      </div>
    </div>
  );
};

export default VoedingForm;
